// Module
var code = "<div class=\"block height-100\"> <h2>Ledgers: Missing Journals</h2> <div id=\"entityGrid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;